module.exports = __webpack_public_path__ + "img/sort_by_alpha.2b974df5.svg";